import React, {Component} from 'react';

import { t } from 'l10n';
import paths from 'paths';
import { Link } from 'components/ReactRouterDomLocalized';

import 'sass/headers/header.scss';

class HeaderActivateRegistration extends Component {

    constructor(props) {
        super(props);

        this.state = {}
    }

    render() {
        const {
            sid,
            status,
            message 
        } = this.props;

        //const success = status === 'success';
 
        return (
            <header className="registration">
                <div className="content">
                    <h1>{t('Account activation')}</h1>
                    <div className="text-activate-registration">
                        <p dangerouslySetInnerHTML={{__html: message }}/>
                        <div className="buttons">
                            <Link to="/?login">
                                <button>{t('Log in')}</button>
                            </Link>
                        </div>
                    </div>
                </div>
            </header>
        )
    }
}

export default HeaderActivateRegistration;


// WEBPACK FOOTER //
// ./src/components/registration/HeaderActivateRegistration.js